import { useState, useEffect } from 'react';
import { addListener } from '../utils/event.js';
import { HAS_WINDOW } from '../utils/window.js';

/** Allows use of this utility in SSR (will simply return `false`) */
const SSR_MEDIA_QUERY_LIST = {
    matches: false,
    addEventListener: () => { },
    removeEventListener: () => { },
};
function matchMediaOrSsr(query) {
    // We don't allow calling window.matchMedia directly, except for right here in this function
    // eslint-disable-next-line no-restricted-syntax
    return HAS_WINDOW ? window.matchMedia(query) : SSR_MEDIA_QUERY_LIST;
}
function useMediaQuery(query) {
    const [matches, setMatches] = useState(query.matches);
    useEffect(() => addListener(query, 'change', (e) => setMatches(e.matches)), [query]);
    return matches;
}

export { matchMediaOrSsr, useMediaQuery };
//# sourceMappingURL=use-media-query.js.map
